function addStringBeforeExtension(imageName, size) { //"small" | "medium" | "large"
    return imageName?.replace(/(\.[\w\d]+)$/, `_${size}$1`);
}

export const getImageURL = ({ image, width = undefined, grey = false, size }) => {
    // if (!image) return ''

    // if (typeof image === 'string') {
    //     return `${import.meta.env.VITE_GOOGLE_STORAGE}/${grey ? "e_grayscale/" : ''}${width ? `c_scale,w_${width}/` : ''}${image}`
    // } else if (!!image?.fileName) {
    //     return `${import.meta.env.VITE_GOOGLE_STORAGE}/${grey ? "e_grayscale/" : ''}${width ? `c_scale,w_${width}/` : ''}${image?.fileName}`
    // }

    if (!image?.name) return ''
    let imageName = image?.name

    if (!!size) {
        imageName = addStringBeforeExtension(imageName, size)
    }
    
    const url = `${image.baseURL}${imageName}`
    return url
}
